import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

const ProviderProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    checkProvider();
  }, []);

  const checkProvider = async () => {
    const {
      data: { user }
    } = await supabase.auth.getUser();

    if (!user) {
      setAllowed(false);
      setLoading(false);
      return;
    }

    const { data: provider } = await supabase
      .from("providers")
      .select("id")
      .eq("user_id", user.id)
      .single();

    setAllowed(!!provider);
    setLoading(false);
  };

  if (loading) return <div>Loading...</div>;

  return allowed
    ? children
    : <Navigate to="/provider/login" />;
};

export default ProviderProtectedRoute;